<span
  class="badge bg-secondary bg-opacity-50 text-gray-600 text-uppercase fw-normal me-2"
  [attr.test-id]="config.type"
>
  {{ config.type | appFormatTextFieldType | translate }}<span *ngIf="config.type !== 'BG_COLOR'" class="fw-bold text-dark"> {{config.minLength}}-{{config.maxLength}}</span>
  <span 
    *ngIf="!config.optional"
    class="text-danger"
    test-id="required"
  >*</span>
</span>
